import { useAuth } from "../AuthProvider";
import AdminGameSetup from './AdminGameSetup';
import PlayerGameSetup from './PlayerGameSetup';
import { ADMIN, GAME_MASTER, PLAYER } from '../Roles';

const GameSetup = ({ game, reloadGame }) => {
    const auth = useAuth();
    const isGameMaster = auth.roles.includes(ADMIN) || auth.roles.includes(GAME_MASTER);
    const isPlayer = auth.roles.includes(PLAYER);
    return (
        <>
            {isGameMaster &&
                <AdminGameSetup game={game} reloadGame={reloadGame} />
            }
            {isPlayer &&
                <PlayerGameSetup game={game} reloadGame={reloadGame} />
            }
        </>
    );
};

export default GameSetup;